import { render, staticRenderFns } from "./avisodefotos.vue?vue&type=template&id=2e017e84"
import script from "./avisodefotos.vue?vue&type=script&lang=js"
export * from "./avisodefotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports